import React, { useEffect, useState } from 'react';

import { Loader2, Pencil, School, X } from 'lucide-react';
import axios from 'axios';

import { useDispatch, useSelector } from 'react-redux';
import { Oval } from 'react-loader-spinner';
import EnhanceFETP from './EnhanceFETP';
import ContactInfo from './ContactInfo';




export const AvailableForModal = ({ isOpen, onClose }) => {
    const dispatch = useDispatch();
    const { selectedUser: user } = useSelector((state) => state.users);

    const [options, setOptions] = useState({
        response_deployment: user?.available?.response_deployment || false,
        mentee_frontline: user?.available?.mentee_frontline || false,
        mentee_intermediate: user?.available?.mentee_intermediate || false,
        mentee_advanced: user?.available?.mentee_advanced || false,
        mentorship_frontline: user?.available?.mentorship_frontline || false,
        mentorship_intermediate: user?.available?.mentorship_intermediate || false,
        mentorship_advanced: user?.available?.mentorship_advanced || false
    });

    useEffect(() => {
        if (user) {
            setOptions({
                response_deployment: user.available?.response_deployment || false,
                mentee_frontline: user.available?.mentee_frontline || false,
                mentee_intermediate: user.available?.mentee_intermediate || false,
                mentee_advanced: user.available?.mentee_advanced || false,
                mentorship_frontline: user.available?.mentorship_frontline || false,
                mentorship_intermediate: user.available?.mentorship_intermediate || false,
                mentorship_advanced: user.available?.mentorship_advanced || false
            });
        }
    }, [user, dispatch]);


    const handleToggle = (option) => {
        if (option === 'response_deployment') {
            setOptions(prev => ({
                ...prev,
                response_deployment: !prev.response_deployment
            }));
        } else if (option === 'mentee') {
            const currentMenteeStatus = options.mentee_frontline ||
                options.mentee_intermediate ||
                options.mentee_advanced;
            setOptions(prev => ({
                ...prev,
                mentee_frontline: !currentMenteeStatus,
                mentee_intermediate: !currentMenteeStatus,
                mentee_advanced: !currentMenteeStatus
            }));
        } else if (option === 'mentorship') {
            const currentMentorshipStatus = options.mentorship_frontline ||
                options.mentorship_intermediate ||
                options.mentorship_advanced;
            setOptions(prev => ({
                ...prev,
                mentorship_frontline: !currentMentorshipStatus,
                mentorship_intermediate: !currentMentorshipStatus,
                mentorship_advanced: !currentMentorshipStatus
            }));
        }
    };

    const handleLevelToggle = (type, level) => {
        setOptions(prev => ({
            ...prev,
            [`${type}_${level.toLowerCase()}`]: !prev[`${type}_${level.toLowerCase()}`]
        }));
    };



    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="relative bg-white rounded-lg w-full max-w-md mx-4">
                <div className="flex justify-between items-center p-4 border-b">
                    <h3 className="text-xl font-semibold text-gray-900">Available for</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        <X size={20} />
                    </button>
                </div>

                <div className="p-4">
                    <div className="space-y-6">
                        {/* Response Deployment */}
                        <div className="flex items-center justify-between">
                            <span className="text-gray-700">Response Deployment</span>
                            <button
                                // onClick={() => handleToggle('response_deployment')}
                                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors
                                ${options.response_deployment ? 'bg-[#1330C5]' : 'bg-gray-200'}`}
                            >
                                <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform
                                    ${options.response_deployment ? 'translate-x-6' : 'translate-x-1'}`}
                                />
                            </button>
                        </div>

                        {/* Mentee Section */}
                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <span className="text-gray-700">Available for mentorship</span>
                                <button
                                    // onClick={() => handleToggle('mentee')}
                                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors
                                    ${(options.mentee_frontline || options.mentee_intermediate || options.mentee_advanced)
                                            ? 'bg-[#1330C5]' : 'bg-gray-200'}`}
                                >
                                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform
                                        ${(options.mentee_frontline || options.mentee_intermediate || options.mentee_advanced)
                                            ? 'translate-x-6' : 'translate-x-1'}`}
                                    />
                                </button>
                            </div>

                            {(options.mentee_frontline || options.mentee_intermediate || options.mentee_advanced) && (
                                <div className="ml-4 space-y-2">
                                    {['Frontline', 'Intermediate', 'Advanced'].map((level) => (
                                        <div key={level} className="flex items-center">
                                            <input
                                                type="checkbox"
                                                id={`mentee-${level}`}
                                                checked={options[`mentee_${level.toLowerCase()}`]}
                                                onChange={() => handleLevelToggle('mentee', level)}
                                                className="w-4 h-4 text-[#1330C5] rounded border-gray-300 focus:ring-[#1330C5]"
                                            />
                                            <label htmlFor={`mentee-${level}`} className="ml-2 text-gray-600">
                                                {level}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Mentorship Section */}
                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <span className="text-gray-700">Available to provide mentorship</span>
                                <button
                                    // onClick={() => handleToggle('mentorship')}
                                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors
                                    ${(options.mentorship_frontline || options.mentorship_intermediate || options.mentorship_advanced)
                                            ? 'bg-[#1330C5]' : 'bg-gray-200'}`}
                                >
                                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform
                                        ${(options.mentorship_frontline || options.mentorship_intermediate || options.mentorship_advanced)
                                            ? 'translate-x-6' : 'translate-x-1'}`}
                                    />
                                </button>
                            </div>

                            {(options.mentorship_frontline || options.mentorship_intermediate || options.mentorship_advanced) && (
                                <div className="ml-4 space-y-2">
                                    {['Frontline', 'Intermediate', 'Advanced'].map((level) => (
                                        <div key={level} className="flex items-center">
                                            <input
                                                type="checkbox"
                                                id={`mentorship-${level}`}
                                                checked={options[`mentorship_${level.toLowerCase()}`]}
                                                onChange={() => handleLevelToggle('mentorship', level)}
                                                className="w-4 h-4 text-[#1330C5] rounded border-gray-300 focus:ring-[#1330C5]"
                                            />
                                            <label htmlFor={`mentorship-${level}`} className="ml-2 text-gray-600">
                                                {level}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
};




const MainProfileCard = ({ profileData }) => {
    const dispatch = useDispatch()







    // Existing state for other modals
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMapModalOpen, setIsMapModalOpen] = useState(false);
    const [isEditProfileModalOpen, setIsEditProfileModalOpen] = useState(false);
    const [isEnhanceFetpModalOpen, setIsEnhanceFetpModalOpen] = useState(false);
    const [isContactInfoModalOpen, setIsContactInfoModalOpen] = useState(false);






    return (
        <div className="w-full mx-auto bg-white rounded-lg shadow-md overflow-hidden">

            <div className="relative sm:h-72 h-52 bg-gray-800 overflow-hidden">
                <img src={profileData?.banner_img} alt="banner" className="w-full h-full object-cover" />

            </div>
            {/* user section */}
            <div className="px-6 py-4 relative">

                <div className="absolute -top-12 sm:-top-20 left-6">
                    <div className="w-20 h-20 sm:w-36 sm:h-36 rounded-full border-4 border-white bg-gray-200 overflow-hidden relative">
                        <img src={profileData?.profile_img} alt="user" className="w-full h-full object-cover" />

                    </div>
                </div>

                {/* user info */}
                <div className="mt-14">
                    <div className='flex justify-end'>

                    </div>
                    <h1 className="text-2xl font-bold text-gray-900">{profileData?.first_name} {profileData?.middle_name} {profileData?.last_name}</h1>
                    <p className="text-gray-600 mt-1 leading-relaxed">
                        {profileData?.headline}
                    </p>

                    <div className="mt-2 text-gray-500 text-sm">
                        <span>{profileData?.location}</span>
                        <span className="mx-2">•</span>

                    </div>
                    

                    <div className='flex gap-2 items-center mt-2'>
                        <div className=" text-sm">
                            <span className="text-[#1330C5] hover:underline cursor-pointer">
                                {profileData?.connections_count} connection(s)
                            </span>
                        </div>

                    </div>
                </div>

                {/* Action buttons */}
                <div className="mt-4 flex flex-wrap gap-2">
                    <button
                        onClick={() => setIsModalOpen(true)}
                        className="px-4 py-1 bg-[#1330C5] text-white rounded-full hover:opacity-60 transition-colors">
                        Available for..
                    </button>
                    {/* <button className="px-4 py-1 border border-[#1330C5] text-[#1330C5] rounded-full hover:bg-blue-50 transition-colors">
                        Add profile section
                    </button> */}
                    <button
                        onClick={() => { setIsEnhanceFetpModalOpen(true) }}
                        className="px-4 py-1 border border-[#1330C5] text-[#1330C5] rounded-full hover:bg-blue-50 transition-colors">
                        Enhance FE(L)TP Info
                    </button>
                    <button
                        onClick={() => { setIsContactInfoModalOpen(true) }}
                        className="px-4 py-1 border border-[#1330C5] text-[#1330C5] rounded-full hover:bg-blue-50 transition-colors">
                        Contact Info
                    </button>
                    <button className="px-4 py-1 border border-gray-400 text-gray-600 rounded-full hover:bg-gray-50 transition-colors">
                        Resources
                    </button>
                </div>

            </div>

            {/* Education section */}
            <div className="px-6 py-2 border-t border-gray-200">
                <div className="flex items-center">
                    <School />
                    <span className="ml-2 text-gray-700">University of Ghana</span>
                </div>
            </div>
            <AvailableForModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
            <EnhanceFETP
                isOpen={isEnhanceFetpModalOpen}
                onClose={() => setIsEnhanceFetpModalOpen(false)}
                userData={profileData}
            />
             <ContactInfo
                isOpen={isContactInfoModalOpen}
                onClose={() => setIsContactInfoModalOpen(false)}
                user={profileData}

            /> 


        </div>

    );
};

export default MainProfileCard;